import * as React from "react";

function SvgTop(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path d="M0 0v16h16V0H0zm13 13H3V3h10v10z" opacity={0.06} fill="#555d63" /><path d="M1.6.7c-.2-.3-.1-.7.2-.7h12.4c.3 0 .4.3.2.7L12.2 3H3.8L1.6.7z" fill="#555d63" /></svg>;
}

export default SvgTop;